/* Protect Diversity — tema Shopify: nav, cart drawer (AJAX), animaciones */
(function(){
  'use strict';

  var header = document.querySelector('.header');
  if (header) window.addEventListener('scroll', function(){ header.classList.toggle('scrolled', window.scrollY > 10); }, { passive:true });

  var mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileNavClose = document.querySelector('.mobile-nav-close');
  if (mobileMenuBtn && mobileNav) mobileMenuBtn.addEventListener('click', function(){ mobileNav.classList.add('open'); document.body.style.overflow='hidden'; });
  if (mobileNavClose && mobileNav) mobileNavClose.addEventListener('click', function(){ mobileNav.classList.remove('open'); document.body.style.overflow=''; });

  function openCart(){ var o=document.querySelector('.cart-overlay'), d=document.querySelector('.cart-drawer'); if(o)o.classList.add('open'); if(d)d.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeCart(){ var o=document.querySelector('.cart-overlay'), d=document.querySelector('.cart-drawer'); if(o)o.classList.remove('open'); if(d)d.classList.remove('open'); document.body.style.overflow=''; }

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('.cart-overlay')) { closeCart(); return; }
    if (e.target.closest('.cart-drawer-close')) { closeCart(); return; }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });

  window.PD = window.PD || {};

  function money(cents){
    var n = (cents/100);
    var s = n.toLocaleString('es-MX', { minimumFractionDigits: (n % 1 === 0 ? 0 : 2), maximumFractionDigits: 2 });
    return '$' + s;
  }

  function updateCount(cart, animate){
    var badges = document.querySelectorAll('.cart-count');
    badges.forEach(function(b){
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      if (animate && cart.item_count > 0) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
  }

  PD.renderCartDrawer = function(cart){
    var items = document.querySelector('.cart-drawer-items');
    var footerEl = document.querySelector('.cart-drawer-footer');
    if (!items) return;
    if (!cart || cart.item_count === 0) {
      items.innerHTML = '<div class="cart-drawer-empty"><p>Tu carrito está vacío</p><a href="/collections/all" class="btn-secondary">Explorar productos</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (footerEl) footerEl.style.display = 'block';
    var html = '';
    cart.items.forEach(function(item){
      var img = item.image ? '<img src="'+item.image+'" alt="'+item.title+'" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">' : '';
      html += '<div class="cart-drawer-item">'+
        '<div class="cart-drawer-item-img" style="overflow:hidden;">'+img+'</div>'+
        '<div class="cart-drawer-item-info">'+
          '<div class="cart-drawer-item-name">'+item.product_title+'</div>'+
          '<div class="cart-drawer-item-price">'+money(item.final_price)+'</div>'+
          '<div class="cart-drawer-item-qty">'+
            '<button data-qty="-1" data-key="'+item.key+'">−</button>'+
            '<span>'+item.quantity+'</span>'+
            '<button data-qty="1" data-key="'+item.key+'">+</button>'+
          '</div>'+
          '<button class="cart-drawer-item-remove" data-remove="'+item.key+'">Eliminar</button>'+
        '</div>'+
      '</div>';
    });
    items.innerHTML = html;
    var sub = document.querySelector('.cart-drawer-subtotal .amount');
    if (sub) sub.textContent = money(cart.total_price);
    var ship = document.querySelector('.cart-drawer-shipping');
    if (ship) ship.textContent = cart.total_price >= 120000 ? 'Envío gratis' : 'Envío gratis en compras desde $1,200';
  };

  PD.refreshCart = function(animate){
    return fetch('/cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateCount(cart, animate); PD.renderCartDrawer(cart); return cart; });
  };

  function changeQty(key, qty){
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id:key, quantity:qty }) })
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateCount(cart); PD.renderCartDrawer(cart); });
  }

  /* qty +/- y eliminar dentro del drawer */
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-qty]');
    if (q) {
      var span = q.parentElement.querySelector('span');
      var current = parseInt(span ? span.textContent : '1', 10);
      var next = Math.max(0, current + parseInt(q.dataset.qty, 10));
      changeQty(q.dataset.key, next);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeQty(rm.dataset.remove, 0); return; }
  });

  /* Agregar al carrito */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.classList.contains('added')) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var original = btn.textContent;
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function(r){ return r.json(); })
      .then(function(){ return PD.refreshCart(true); })
      .then(function(){
        openCart();
        btn.textContent = '✓ AGREGADO'; btn.classList.add('added');
        setTimeout(function(){ btn.textContent = original; btn.classList.remove('added'); }, 1200);
      });
  });

  /* Reveal animations */
  if ('IntersectionObserver' in window) {
    var els = document.querySelectorAll('.reveal');
    if (els.length) {
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('visible'); obs.unobserve(en.target); } });
      }, { threshold:0.08, rootMargin:'0px 0px -80px 0px' });
      els.forEach(function(el){ obs.observe(el); });
    }
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('visible'); });
  }

  PD.refreshCart(false);
})();
